import * as actions from '../actions/user';

const getInitialState = () => ({
  data: null,
  error: null,
  id: null,
  loaded: false,
  loading: false,
  organizationId: null,
});

const userReducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case actions.USR_FETCH: {
      return {
        ...state,
        data: null,
        error: null,
        id: action.payload.userId,
        loaded: false,
        loading: true,
        organizationId: action.payload.organizationId,
      };
    }
    case actions.USR_FETCH_ERROR: {
      return {
        ...state,
        data: null,
        error: action.payload,
        loaded: true,
        loading: false,
      };
    }
    case actions.USR_FETCH_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        loaded: true,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export default userReducer;
